import { Modal } from 'react-bootstrap'
import ComponentePrivado from '../../../components/roles/ComponentePrivado'
import { Roles } from '../../../utils/Roles'
import useHasPermiso from '../../../hooks/autenticacion/useHasPermiso'
import { UseFormHandleSubmit } from 'react-hook-form'
import { TUsuarioForm } from '../models'

type Props = {
  isModoEditar: boolean
  isLoadingActualizar: boolean
  cerrarModal: () => void
  handleSubmit: UseFormHandleSubmit<TUsuarioForm>
  onSubmit: (data: TUsuarioForm, accion: string) => void
}

/**
 * Footer del modal de usuario con dos acciones:
 * - "Actualizar" (solo editar): persiste datos sin cambiar sitios.
 * - "Siguiente": valida el formulario y avanza al paso de seleccion de sitios.
 */
export const ModalUsuarioFooter = ({
  isModoEditar,
  isLoadingActualizar,
  cerrarModal,
  handleSubmit,
  onSubmit,
}: Props) => {
  const { hasPermiso } = useHasPermiso()
  return (
    <Modal.Footer
      className={`${hasPermiso([Roles.roleUsuariosCrear]) ? '' : 'overlay overlay-allowed'}`}>
      <div className={`d-flex justify-content-between flex-grow-1 `}>
        <div className='d-flex flex-grow-1'>
          {isModoEditar && (
            <>
              <ComponentePrivado rolMostrarPorPermiso={[Roles.roleUsuariosCrear]}>
                <button
                  disabled={isLoadingActualizar}
                  className='btn btn-primary p-3'
                  form='form-usuario'
                  type='button'
                  onClick={handleSubmit((e) => {
                    onSubmit({ ...e }, 'actualizar')
                  })}>
                  Actualizar
                </button>
              </ComponentePrivado>
            </>
          )}
          <button
            disabled={isLoadingActualizar}
            type='reset'
            className='btn text-hover-dark btn-cancelar text-align-end'
            onClick={cerrarModal}>
            Cancelar
          </button>
        </div>
        <div>
          <ComponentePrivado rolMostrarPorPermiso={[Roles.roleUsuariosCrear]}>
            <button
              disabled={isLoadingActualizar}
              className={`btn btn-${isModoEditar ? 'light-' : ''}primary p-3`}
              form='form-usuario'
              type='button'
              onClick={handleSubmit((e) => {
                onSubmit({ ...e }, 'siguiente')
              })}>
              Siguiente
              <span>
                <i className='ms-2 fa-solid fa-arrow-right'></i>
              </span>
            </button>
          </ComponentePrivado>
        </div>
      </div>
    </Modal.Footer>
  )
}
